import React from 'react';
import type { IconPropsSVG } from './types';

export function RGB(props: IconPropsSVG): React.JSX.Element {
    return (
        <svg
            viewBox="1 -10 511.99999 511"
            {...props}
        >
            <g fill="currentColor">
                <path
                    d="M 405.5 150 C 405.5 232.566406 338.566406 299.5 256 299.5 C 173.433594 299.5 106.5 232.566406 106.5 150 C 106.5 67.433594 173.433594 0.5 256 0.5 C 338.566406 0.5 405.5 67.433594 405.5 150 Z M 405.5 150 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(25.882353%,75.294118%,88.627451%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 512 342.921875 C 512 425.488281 445.066406 492.421875 362.5 492.421875 C 279.933594 492.421875 213 425.488281 213 342.921875 C 213 260.355469 279.933594 193.421875 362.5 193.421875 C 445.066406 193.421875 512 260.355469 512 342.921875 Z M 512 342.921875 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(100%,81.568627%,38.039216%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 220.746094 295.308594 C 232.050781 298.039062 243.855469 299.5 256 299.5 C 321.917969 299.5 377.871094 256.835938 397.753906 197.613281 C 386.449219 194.878906 374.644531 193.421875 362.5 193.421875 C 296.582031 193.421875 240.628906 236.085938 220.746094 295.308594 Z M 220.746094 295.308594 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(28.627451%,74.117647%,56.470588%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 299 342.921875 C 299 425.488281 232.066406 492.421875 149.5 492.421875 C 66.933594 492.421875 0 425.488281 0 342.921875 C 0 260.355469 66.933594 193.421875 149.5 193.421875 C 232.066406 193.421875 299 260.355469 299 342.921875 Z M 299 342.921875 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(98.039216%,43.921569%,69.803922%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 114.246094 197.613281 C 134.128906 256.835938 190.082031 299.5 256 299.5 C 268.144531 299.5 279.949219 298.039062 291.253906 295.308594 C 271.371094 236.085938 215.417969 193.421875 149.5 193.421875 C 137.355469 193.421875 125.550781 194.878906 114.246094 197.613281 Z M 114.246094 197.613281 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(68.627451%,48.235294%,77.647059%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 213 342.921875 C 213 383.800781 229.414062 420.839844 256 447.828125 C 282.585938 420.839844 299 383.800781 299 342.921875 C 299 302.042969 282.585938 265.003906 256 238.015625 C 229.414062 265.003906 213 302.042969 213 342.921875 Z M 213 342.921875 "
                    style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'rgb(93.72549%,38.039216%,13.333333%)',
                        fillOpacity: 1,
                    }}
                />
                <path
                    d="M 291.253906 295.320312 C 279.949219 298.046875 268.140625 299.5 256 299.5 C 243.859375 299.5 232.050781 298.046875 220.746094 295.320312 C 228.058594 273.542969 240.242188 254.015625 256 238.015625 C 271.757812 254.015625 283.941406 273.542969 291.253906 295.320312 Z M 291.253906 295.320312 "
                    style={{ stroke: 'none', fillRule: 'nonzero', fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                />
            </g>
        </svg>
    );
}
